var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { Controller, useFormContext } from "react-hook-form";
import { RecekNumberField, RecekTextField } from "../inputs";
/** Fields rendered as numeric inputs (empty string maps to undefined). */
var NUMERIC_FIELDS = new Set(["ageFrom", "ageTo", "editionNumber"]);
var FIELD_LABELS = {
    ageFrom: "ui-br-agency.title.ageFrom.field.label",
    ageTo: "ui-br-agency.title.ageTo.field.label",
    doi: "ui-br-agency.title.doi.field.label",
    editionNumber: "ui-br-agency.title.editionNumber.field.label",
    editionStatement: "ui-br-agency.title.editionStatement.field.label",
    illustrationsNote: "ui-br-agency.title.illustrationsNote.field.label",
    commentForAgency: "ui-br-agency.title.commentForAgency.field.label",
};
/** Consecutive field pairs rendered side by side (half width each). */
var PAIRS = [
    ["ageFrom", "ageTo"],
];
var AdditionalField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    var isNumeric = NUMERIC_FIELDS.has(name);
    return (React.createElement(Controller, { control: control, name: name, render: function (_a) {
            var _b, _c;
            var field = _a.field, fieldState = _a.fieldState;
            return isNumeric ? (React.createElement(RecekNumberField, __assign({}, field, { value: field.value, labelId: FIELD_LABELS[name], error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }))) : (React.createElement(RecekTextField, __assign({}, field, { labelId: FIELD_LABELS[name], error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message })));
        } }));
};
/**
 * Renders a chosen subset of the title's scalar fields, in the given order.
 * Known numeric pairs (Věk od/do) are laid out side by side
 * when both appear consecutively. Used to distribute these fields across the
 * form tabs (basic / publisher / content / cover) instead of one "Dodatek" tab.
 */
var TitleAdditionalInfoForm = function (_a) {
    var fields = _a.fields;
    var rows = [];
    var _loop_1 = function (i) {
        var name_1 = fields[i];
        var pair = PAIRS.find(function (p) { return p[0] === name_1 && fields[i + 1] === p[1]; });
        if (pair) {
            rows.push(React.createElement(Row, { key: name_1 },
                React.createElement(Col, { xs: 6 },
                    React.createElement(AdditionalField, { name: pair[0] })),
                React.createElement(Col, { xs: 6 },
                    React.createElement(AdditionalField, { name: pair[1] }))));
            i += 1;
        }
        else {
            rows.push(React.createElement(Row, { key: name_1 },
                React.createElement(Col, { xs: 12 },
                    React.createElement(AdditionalField, { name: name_1 }))));
        }
        out_i_1 = i;
    };
    var out_i_1;
    for (var i = 0; i < fields.length; i += 1) {
        _loop_1(i);
        i = out_i_1;
    }
    return React.createElement(React.Fragment, null, rows);
};
export default TitleAdditionalInfoForm;
